import CFHApi from './CFHApi';
import ConfigApi from './ConfigApi';
import DataappiApi from './DataappiApi';
import EFTradeApi from './EFTradeApi';
import EMAnoticeApi from './EMAnoticeApi';
import EMHqApi from './EMHqApi';
import EMNewApi from './EMNewApi';
import FundApi from './FundApi';
import FundComApi from './FundComApi';
import FundDgs from './FundDgsApi';
import GroupApi from './GroupApi';
import JijinbaApi from './JijinbaApi';
import NewsApi from './NewsApi';
import OptionApi from './OptionApi';
import Push2His from './Push2His';
import StokeApi from './StokeApi';

function minxs() {
  return (target) => {
    // eslint-disable-next-line no-param-reassign
    target.prototype.apiModules = {
      FundApi,
      NewsApi,
      JijinbaApi,
      CFHApi,
      EMHqApi,
      GroupApi,
      StokeApi,
      EFTradeApi,
      EMAnoticeApi,
      EMNewApi,
      DataappiApi,
      ConfigApi,
      FundComApi,
      FundDgs,
      Push2His,
      OptionApi,
    };
  };
}

@minxs()
class HttpModule {
  useRequests(key, ...args) {
    const temps = key.split('.');
    const name = temps[0];
    const method = temps[1];
    return this.apiModules[name][method](...args);
  }

  setUserConfig(...args) {
    Object.keys(this.apiModules).forEach((name) => {
      if (this.apiModules[name].setUserConfig) {
        this.apiModules[name].setUserConfig(...args);
      }
    });
  }
}

export default new HttpModule();
